















































































































































































import { defineComponent, computed, ref } from '@vue/composition-api'

import { Gender, IReceipt, supplierName } from '@/types/receipt'

import { AppInput, AppIcon, MasterAutocomplete } from '@/components/atoms'
import { QuestionnaireAnswerEntity } from '../../../../api/@types'
import moment from 'moment'
import { dateToDisplay } from '@/utils/dateFormatter'

type Props = {
  receipt: IReceipt | null
  questionnaireAnswer: QuestionnaireAnswerEntity
}

export default defineComponent({
  name: 'MetaTable',
  components: { AppInput, AppIcon, MasterAutocomplete },
  props: {
    receipt: {
      type: Object,
      default: () => ({}),
    },
    questionnaireAnswer: {
      type: Object,
      default: () => ({}),
    },
  },
  filters: {
    omittedText(text: string): string {
      return text.length > 10 ? text.slice(0, 10) + '…' : text
    },
  },
  setup(props: Props) {
    const details = computed(() => {
      return [
        {
          label: '回答ID',
          value: props.questionnaireAnswer.id,
        },
        {
          label: '回答日時',
          value: moment(props.questionnaireAnswer.answeredAt).format(
            'YYYY/MM/DD HH:mm',
          ),
        },
      ]
    })
    const metas = computed(() => {
      if (props.receipt === null) {
        return []
      }
      return [
        {
          label: '流入元',
          value: supplierName(props.receipt.supplier),
        },
        {
          label: 'モニターID',
          value: props.receipt.monitorId || '',
        },
        {
          label: '性別',
          value:
            props.receipt.monitorGender === Gender.MALE
              ? '男性'
              : props.receipt.monitorGender === Gender.FEMALE
              ? '女性'
              : '不明',
        },
        {
          label: '年齢',
          value: props.receipt.monitorAge || '',
        },
        {
          label: '都道府県',
          value: props.receipt.monitorPrefecture || '',
        },
        {
          label: '既婚',
          value:
            props.receipt.monitorIsMarried === null
              ? ''
              : props.receipt.monitorIsMarried
              ? 'Yes'
              : 'No',
        },
      ]
    })

    const qDateRange = computed(() => {
      return `公開期間: ${moment(
        props.questionnaireAnswer.questionnaire.releaseAt,
      ).format('YYYY/MM/DD HH:mm')} ~ ${moment(
        props.questionnaireAnswer.questionnaire.finishAt,
      ).format('YYYY/MM/DD HH:mm')}`
    })

    const dialog = ref<boolean>(false)

    const importedToDisplay = computed(() => {
      if (props.receipt === null) {
        return ''
      }
      return dateToDisplay(props.receipt.importedAt)
    })

    const dateTimeToDisplay = computed(() => {
      if (props.receipt === null) {
        return ''
      }
      return dateToDisplay(props.receipt.dateTime)
    })

    return {
      details,
      metas,
      qDateRange,
      dialog,
      importedToDisplay,
      dateTimeToDisplay,
    }
  },
})
